<template>
  <qc-container title="故障维修详情" v-if="order" show-divider show-return>
    <el-descriptions :column="2" border>
      <el-descriptions-item label-class-name="w100" label="订单编号">{{order.code}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="状态">{{order.statusDesc}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="故障说明" :span="2">
        {{order.content}}
        <image-show v-if="order.applyList&&order.applyList.length>0"  :images="order.applyList.map(item=>filePath+item.url)"></image-show>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="申请时间">{{order.createTime}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="联系电话">{{order.mobile}}</el-descriptions-item>
      <el-descriptions-item v-if="order.startTime" label-class-name="w100" label="开始时间">{{order.startTime}}</el-descriptions-item>
      <el-descriptions-item v-if="order.payTime" label-class-name="w100" label="支付时间">{{order.payTime}}</el-descriptions-item>
      <el-descriptions-item v-if="order.cancelTime" label-class-name="w100" label="取消时间">{{order.cancelTime}}</el-descriptions-item>
      <el-descriptions-item v-if="order.finishTime" label-class-name="w100" label="维修完成时间">{{order.finishTime}}</el-descriptions-item>
      <el-descriptions-item v-if="order.confirmTime" label-class-name="w100" label="修复确认时间">{{order.confirmTime}}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions class="mt20" v-if="order.repairText" title="费用说明" :column="1" border>
      <el-descriptions-item label-class-name="w100" label="维修费用">￥{{order.money}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="维修说明">
        <div v-html="order.repairText"></div>
        <image-show v-if="order.repairList&&order.repairList.length>0"  :images="order.repairList.map(item=>filePath+item.url)"></image-show>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class="mt20" v-if="order.finishText" title="维修明细" :column="1" border>
      <el-descriptions-item label-class-name="w100" label="是否修复">{{ order.isFinish?"是":"否" }}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="维修说明">
        <div v-html="order.finishText"></div>
        <image-show v-if="order.finishList&&order.finishList.length>0"  :images="order.finishList.map(item=>filePath+item.url)"></image-show>
      </el-descriptions-item>
    </el-descriptions>

    <t-table class="mt20" border :header="tableHeader" :data="order.goodsList">
      <template #before>
        <el-table-column label="商品名称" >
          <template #default="scope">
            <div class="goods-tag">
              <img class="table-img" :src="filePath+scope.row.picture">
              <div class="flex-1 ml20">
                <div class="bold">{{ scope.row.name}}</div>
                <div>编号:{{ scope.row.code}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </template>
    </t-table>
    <return-box></return-box>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import ReturnBox from "@/components/home/return-box.vue";
import ImageShow from "@/components/base/image-show.vue";
import TTable from "@/components/el/t-table.vue";

export default {
  name: "repair-detail",
  components: {TTable, ImageShow, ReturnBox, QcContainer},
  data() {
    return {
      order:null,
      tableHeader: [
        {prop: "property",label: "属性",width: 200},
      ],
    }
  },
  mixins: [tableBase],
  methods: {

  },
  mounted() {
      if (this.$route.query && this.$route.query.id) {
          this.simplePost("/api/mgr/order/repair/getDetail", {id: this.$route.query.id}, result => {
              this.order = result.data;
          });
      }
  }
}
</script>


<style lang="less" scoped>
.goods-tag{
  display: flex;
  .flex-1 div{
    line-height: 18px;
  }
}
.table-img{
  width: 50px;
  height:50px;
}
.sumMoney{
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  div{
    line-height: 40px;
  }
}
</style>
